import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import BASE_URL from '../../config';

const LoginDe = ({ setAuthToken }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/api/login/`, {
        email,
        password,
      });

      setAuthToken(response.data.token);
      localStorage.setItem('authToken', response.data.token);
      setMessage('Erfolgreich angemeldet.');
      navigate('/');
    } catch (error) {
      if (error.response && error.response.data) {
        const data = error.response.data;
        const msg = data.detail || data.message || JSON.stringify(data);
        setMessage(`Anmeldung fehlgeschlagen: ${msg}`);
      } else if (error.request) {
        setMessage('Anmeldung fehlgeschlagen: Keine Antwort vom Server.');
      } else {
        setMessage(`Anmeldung fehlgeschlagen: ${error.message}`);
      }
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2 className="auth-title">Anmelden</h2>
        <p className="auth-subtitle">Willkommen zurück bei Vegbox</p>
        <div className="mb-3">
          <label className="auth-label">E-Mail</label>
          <input
            type="email"
            className="form-control auth-input"
            placeholder="du@beispiel.de"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="mb-3">
          <label className="auth-label">Passwort</label>
          <input
            type="password"
            className="form-control auth-input"
            placeholder="••••••••"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className="auth-links">
          <a href="/forgotpassword">Passwort vergessen?</a>
          <a href="/register">Konto erstellen</a>
        </div>
        <button className="auth-btn" onClick={handleLogin}>
          Anmelden
        </button>
        {message && <p className="auth-message">{message}</p>}
      </div>
    </div>
  );
};

export default LoginDe;
